/**
 * @fileoverview Axios instance for the internal Hans ops console.
 *
 * Same configuration as the instructor api.js but redirects to /ops/login on
 * 401. A fourth auth surface alongside api.js (instructor), studentApi.js
 * (student) and orgApi.js (organization admin) — each portal owns its own
 * cookie and its own 401 destination, so a expired session never bounces an
 * operator into a different portal's login.
 */

import axios from "axios";

import BACKEND_URL from "./backendUrl";

const opsApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

opsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !window.location.pathname.startsWith("/ops/login") &&
      !window.location.pathname.startsWith("/ops/forgot-password") &&
      !window.location.pathname.startsWith("/ops/reset-password")
    ) {
      window.location.href = "/ops/login";
    }
    return Promise.reject(error);
  }
);

export default opsApi;

/**
 * Extract a human-readable error message from an Axios error (mirrors
 * orgApi.js's getOrgErrorMessage), handling structured `{code, message}` details.
 */
export function getOpsErrorMessage(error, fallback = "Something went wrong") {
  const detail = error.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || d.message || JSON.stringify(d)).join(", ");
  if (typeof detail.message === "string") return detail.message;
  return fallback;
}
